const { useEffect } = require("react");

const PrivacyPolicyRedirect = () => {
  const privacyPolicyLink = "https://storage.googleapis.com/noki_public/Noki_%20Privacy%20Policy.pdf";

  useEffect(() => {
    try {
      window.location.href = privacyPolicyLink;
    } catch (error) {
      console.error("Redirection failed:", error);
    }
  }, []);

  return null;
};

export default PrivacyPolicyRedirect;
